export const UNSAVED_CHANGES_DETECTED_MESSAGE =
  'You have unsaved changes. Your changes will be lost if you continue. Are you sure you want to discard them?';

export const CANCEL_BUTTON_LABEL = 'Stay here';
